import React, { useContext, useMemo } from "react";
import { Navigate } from "react-router-dom";

import Tabs from "components/ui/tabs/Tabs";
import { AuthContext } from "shared/context/auth-context";
import { isAdminOrImpersonating } from "shared/util/auth/adminAccess";
import ArventoApiHealthCheck from "features/health-checks/ArventoApiHealthCheck";

// "Health Checks" — yalnızca super_admin veya admin impersonation oturumlarında erişilebilir.
// Sol tarafta dikey sekmeler; ilk sekme "Arvento Api". Yeni kontroller buraya sekme olarak eklenebilir.
const HealthChecksPage = () => {
  const auth = useContext(AuthContext);

  const tabs = useMemo(
    () => [
      {
        id: "arvento-api",
        label: "Arvento Api",
        content: <ArventoApiHealthCheck />,
      },
    ],
    [],
  );

  if (!isAdminOrImpersonating(auth)) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <React.Fragment>
      <Tabs tabs={tabs} isVertical={true} id="health-checks-page" initialTabIndex={0} />
    </React.Fragment>
  );
};

export default HealthChecksPage;
